import { useQueryClient, type QueryKey } from '@tanstack/react-query';

export function useTableRefresh(queryKey: QueryKey) {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey });
}
